var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_803)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1735_803)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1158 7.12061C9.17963 7.12061 10.8527 5.792 10.8527 4.15308C10.8527 2.51416 9.17963 1.18555 7.1158 1.18555C5.05197 1.18555 3.37891 2.51416 3.37891 4.15308C3.37891 5.30712 4.20844 6.3073 5.41983 6.7981C5.58426 7.45403 5.07651 7.94568 4.56875 8.10995C5.72654 8.55945 6.41668 7.66992 6.83041 7.11209C6.92461 7.11774 7.01978 7.12061 7.1158 7.12061Z",
    fill: "#E00000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0257 20.474C15.2697 19.6827 11.5894 21.0236 10.3438 21.7929C15.0998 20.9356 19.5727 22.5348 21.2147 23.4416L20.0257 20.474Z",
    fill: "#E00000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93635 22.2559L5.50682 18.3996C5.8802 18.5338 6.301 18.6425 6.76924 18.7256C7.4636 18.8515 8.34262 18.8569 9.40631 18.742C10.4346 18.6309 11.3078 18.4087 12.0261 18.0754C12.7956 17.7183 13.4158 17.3044 13.8867 16.8335C14.4228 16.3007 14.7975 15.7672 15.0108 15.2328C15.2399 14.6785 15.3215 14.0853 15.2557 13.4533C15.188 12.8032 15.0113 12.311 14.7255 11.9766C14.3789 11.5758 14.0003 11.2971 13.5896 11.1406C13.1593 10.968 12.6549 10.8581 12.0763 10.8111C11.8047 10.7857 11.4907 10.7831 11.1343 10.8033C10.7937 10.8036 10.5515 10.8024 10.4078 10.7996C9.6557 10.8079 9.10236 10.8311 8.7478 10.8694C8.34005 10.9135 7.84876 10.9301 7.27394 10.9191C6.87828 10.9071 6.52035 10.8271 6.20017 10.6791C5.93693 10.5614 5.78744 10.331 5.75171 9.98793C5.73102 9.78929 5.78125 9.58299 5.90239 9.36903C6.05334 9.09706 6.24539 8.87543 6.47854 8.70414C7.04504 8.80728 7.6474 8.82437 8.28562 8.75541C9.06566 8.67112 9.72898 8.49901 10.2756 8.23907C10.8222 7.97913 11.3221 7.61467 11.7752 7.1457C12.1472 6.75853 12.445 6.26069 12.6685 5.65218C12.864 5.11973 12.9251 4.50138 12.8517 3.79711C12.7709 3.02061 12.5614 2.38584 12.2232 1.8928L12.408 1.8457C13.8623 1.85579 15.1741 2.01951 16.2128 2.22507L20.8839 18.7938C12.5948 17.6727 7.46508 20.6347 5.93635 22.2559ZM13.1259 14.1765C13.0902 13.8334 12.9734 13.5721 12.7754 13.3926C12.5755 13.195 12.3015 13.0603 11.9534 12.9883C11.6053 12.9164 11.2334 12.8744 10.8378 12.8624C10.2629 12.8514 9.81502 12.8542 9.49404 12.8706L8.079 12.9687C7.99036 12.9783 7.53265 12.973 6.70587 12.9527C6.21808 13.2611 5.8325 13.6041 5.54912 13.9817C5.26763 14.3773 5.15227 14.8189 5.20305 15.3065C5.23502 15.6135 5.34488 15.8938 5.53265 16.1474C5.71853 16.383 5.98137 16.5829 6.32116 16.747C6.67868 16.9093 7.09355 17.0197 7.56577 17.0782C8.05572 17.1348 8.62866 17.1277 9.2846 17.0568C9.83418 16.9974 10.3949 16.8729 10.9668 16.6833C11.4183 16.5432 11.8259 16.3257 12.1896 16.0307C12.5216 15.7757 12.7612 15.4942 12.9084 15.1861C13.0714 14.858 13.1351 14.5224 13.0993 14.1793L13.1259 14.1765Z",
    fill: "url(#paint0_linear_1735_803)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_803",
    x1: 20.884,
    y1: 12.0508,
    x2: 5.19141,
    y2: 12.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4797,
    height: 23.4797,
    fill: "white",
    transform: "translate(0.738281 0.492188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1735_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4797,
    height: 23.4797,
    fill: "white",
    transform: "translate(0.535156 0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocial);
export default __webpack_public_path__ + "static/media/icon-social.36f2b6e20e89d8bcf4d269b94ffa18b8.svg";
export { ForwardRef as ReactComponent };